import React, { useState } from 'react';

import { EmbeddedYoutubeVideo } from '../../../../components/EmbeddedYoutubeVideo';
import { getImgSrcSet } from '../../../../utils';

import styles from './styles.sass';

const PLACEHOLDER_IMAGE_URLS = [
  'images/homepage/video.png',
  'images/homepage/video@2x.png',
  'images/homepage/video@3x.png',
];

const VideoPlayer = () => {
  const [showVideo, toggleVideo] = useState(false);
  const srcSetValue = getImgSrcSet(PLACEHOLDER_IMAGE_URLS);
  if (showVideo)
    return (
      <EmbeddedYoutubeVideo
        title="Anchor: The Easiest Way to Start a Podcast"
        youtubePlaylistId="PLJ_1GxcJR2S_7SbiQo3tdfVvJR6tLnS8d"
        paddingBottomOffset="56.25%"
        youtubeEmbedParameters={{
          autoplay: 1,
          controls: 1,
          modestbranding: 1,
          loop: 1,
          cc_load_policy: 1,
          mute: 1,
          rel: 0,
        }}
      />
    );
  return (
    <button
      className={styles.placeholderButton}
      type="button"
      onClick={() => toggleVideo(true)}
      aria-label="Show Anchor demonstration video"
    >
      <img
        className={styles.placeholderImage}
        srcSet={srcSetValue}
        alt="Video thumbnail for Anchor demonstration"
      />
    </button>
  );
};

export { VideoPlayer };
